
import { FAQ_VIEW } from '~/const/api/faq';
import LayoutContainer from '~/components/layout/Container';
import FaqBanner from '@/components/faq/FaqBanner';

export default {
    name: 'FAQItem',
    components: {
        LayoutContainer,
        FaqBanner
    },
    data() {
        return {
            item: null
        }
    },
    async fetch() {
        await this.$axios(FAQ_VIEW(this.$route.params.slug))
            .then(({data}) => {
                this.item = data?.item
            })
            .catch(() => {
                this.$router.push({
                    name: 'faq'
                })
            })
    },
    head() {
        if (this.item) {
            const head = { meta: [] };
            head.title = `${this.item.question} | Платформа Ко-Фи`;
            head.meta.push(
                {
                    hid: 'description',
                    name: 'description',
                    content: `${this.item.question} Вопросы и ответы от краудлендинговой платформы`
                }
            )
            return head;
        }
        return {};
    }
}
